import React from "react";
import "./Footer.css";
import WhatsAppQR from "../assets/images/WhatsAppQR.jpeg";
import { Link } from "react-router-dom";
import {
  FaWhatsapp,
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
  FaSearch, FaPhone, FaEnvelope, FaGlobe
} from "react-icons/fa";
const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* ABOUT */}
        <div className="footer-box">
          <h3>E-Advisors Solution</h3>
          <p>
            Your trusted partner for business registration,
            taxation, and compliance services.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-box">
          <h3>Quick Links</h3>
          <ul>
            <li className="contact-item" >
              <Link to="/">
                Home
              </Link>
            </li>
{/* 
            <li>Services</li>
            <li>Contact</li> */}
            <li>
              <Link to="/about">
              About
              </Link>
              </li>
          </ul>
        </div>
        <div className="footer-box">
          <h3>Policy</h3>

          <ul>
            <li className="contact-item">
              <Link to="/confidentialityPolicy">
                Confidentiality Policy
              </Link>
            </li>

            <li className="contact-item">
              <Link to="/privacy-Policy">
                Privacy Policy
              </Link>
            </li>

            <li className="contact-item">
              <Link to="/refundPolicy">
                Refund Terms & Conditions
              </Link>
            </li>

            <li className="contact-item">
              <Link to="/termsConditions">
                Terms & Conditions
              </Link>
            </li>
          </ul>
        </div>




        {/* CONTACT */}
        <div className="footer-box">
          <h3>Contact</h3>

          {/* EMAIL */}
          <a href="mailto:Support@e-advisorssolution.com" className="contact-item">
            <FaEnvelope className="contact-icon email" />
            <span>Support@e-advisorssolution.com</span>
          </a>

          {/* PHONE */}
          <a href="tel:9506487032" className="contact-item">
            <FaPhone className="contact-icon phone" />
            <span>9218103915</span>
          </a>

          {/* INDIA */}
          <div className="contact-item">
            <FaGlobe className="contact-icon" />
            <span>India</span>
          </div>
        </div>
        <div className="whatsapp-footer">

          <a
            href="https://wa.me/919218103915"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={WhatsAppQR}
              alt="WhatsApp QR"
              className="footer-qr"
            />
          </a>

        </div>

      </div>

      <div className="footer-bottom">
        © 2026 EAdvisors Solution. All Rights Reserved.
      </div>

    </footer>
  );
};

export default Footer;